import React, { useState, useEffect } from 'react';
//import { useSearchParams, useNavigate } from "react-router-dom";
import landing_img from './images/landing.jpg';
import './common/css/App.css';
import './css/profile.css'
import './profile/css/main.css'
import Footer from "./components/footer/Footer"
import Header from "./components/header/Header"
import Navbar from "./profile/navbar.js"
import ShoppingHistory from "./profile/history";
import UserProfile from "./profile/userProfile";
import CompaniesPage from "./profile/companies";
import UserAgreement from "./pages/userAgreement";
import axios from 'axios'
import $ from 'jquery'; 
import { Auth } from 'aws-amplify';
 


const initialPageInfo = {
  page: 'loading', 
  lastEkukkaPage: ''
}


function Profile(props) {
  const [user, updateUser] = useState(null);
  const [userProfileComplete, SetUserProfileComplete] = useState(false);
  const [pageInfo, updatePageInfo] = useState(initialPageInfo)
  //const [searchParams, setSearchParams] = useSearchParams();
  const queryParameters = new URLSearchParams(window.location.search)
 //const navigate = useNavigate();
 const callCustomerBackend = "https://" +  window.location.hostname + "/php/controllers/Customer.php";
 //console.log(callCustomerBackend)

  const navigateToHistory = () => {
    changeTo('history');
  };
  const navigateToUserProfile = () => {
    changeTo('userProfile');
  };



  const changeTo = (pageToGo) =>{
    if (pageToGo == "back_to_shop"){
      props.backToShop()
    }
    else {
      updatePageInfo(() => ({ ...pageInfo, page: pageToGo }))
      document.location.hash = pageToGo;
      if (pageToGo == 'log_out'){
        window.location.href = window.location.origin+'#logout';
      }
    }
  }
  function loadJquery(){
    $('.nav_bar li').click(function(){
      if (!$(this).hasClass('selected')){
        //const newpage = $(this).attr("class")
        $('.nav_bar li.selected').removeClass('selected')
        $(this).addClass('selected')
      }
    })
  }
  document.addEventListener("DOMContentLoaded", function() {
    loadJquery()

  })


  useEffect(() => {
    checkUser()
    checkUserProfileComplete()
  }, [])

  async function checkUserProfileComplete() {
    try {
      const user = await Auth.currentAuthenticatedUser()
      const post_data = {
        'function' : 'user',
        "authToken" : user.signInUserSession.accessToken.jwtToken
      }

      axios.post(callCustomerBackend, post_data)
      .then(result => {
          if (result.data.status == "200"){

              if(result.data.content[0].phoneNumber && result.data.content[0].email && result.data.content[0].postalCode && result.data.content[0].streetAddress && result.data.content[0].city && result.data.content[0].Country){
                SetUserProfileComplete(true)
              }

          }
      }).catch(error => function(){
        console.log('error:' + error)
      })

    }catch(err){
     console.log(err)
    }
  }

  async function checkUser () {
    try {
       const user = await Auth.currentAuthenticatedUser()
       updateUser(user)
       await checkPage();
       const { page } = pageInfo;
       if (page == 'loading'){
         updatePageInfo(() => ({ ...pageInfo, page: "landing" }))
      }
     }
     catch(err){
       window.location.href= window.location.origin
     }
  }
  function checkPage(){
    const referer = queryParameters.get("referer");
    if ((referer !== "")&&( referer !== null)){
      updatePageInfo(() => ({ ...pageInfo, lastEkukkaPage: referer }))
    }
    const page = document.location.hash.substring(1);
    const allowedPages = ["loading", "landing", "userProfile" , "history", "companies" ]
    if (( page !== "") && (allowedPages.indexOf(page) > -1)){
      if (page === 'logout'){
        Auth.signOut();
        window.location.href = window.location.origin+'#logout';
        return;
      }
     updatePageInfo(() => ({ ...pageInfo, page: page }))
     pageInfo.page = page
     $('.nav_bar .selected').removeClass('selected')
     $('.nav_bar .'+page+'').addClass('selected')
    }

  }
  const capitalizeFirst = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const goToeKukka = () => {
    window.location.href= "https://ekukka.fi"
  }

  return (
    <>
    <div className="app">
      <Header />
      <div className="flex">
      <Navbar onChange={value => changeTo(value) }/>

      {
        pageInfo.page === 'loading' && (
            <div className="content">
              <div className="h1">Ladataan profiilia...</div>
            </div>
        )
      }
      {
        pageInfo.page === 'landing' && (
            <div className="content">
              <div className="h1"> Tervetuloa takaisin, {capitalizeFirst(user.attributes.given_name)}</div>
              {!userProfileComplete &&  <div className="plainText"> Kukkien tilaaminen on nopeampaa ja helpompaa, kun täydennät <span onClick={navigateToUserProfile} className="underline_text">Omat tiedot</span>.</div>}

              <div className="plainText"> Kuitti hukassa? Haluatko selata tekemiäsi kukkatilauksia? Klikkaa valikosta <span onClick={navigateToHistory} className="underline_text">Omat tilaukset</span>.</div>
              <div className="plainText"> Salasanan vaihtaminen ja yhteystietojen muuttaminen onnistuu kohdassa <span onClick={navigateToUserProfile} className="underline_text">Omat tiedot</span>.</div>

              <h3 className="underline_text" onClick={() => props.backToShop()}>Takaisin ostoksille</h3>

              <img className="landing_img" src={landing_img}/>
            </div>
        )
      }
      {
        pageInfo.page === 'userProfile' && (
          <UserProfile  onChange={value => changeTo(value)} user={user}/>
        )
      }
      {
        pageInfo.page === 'companies' && (
          <CompaniesPage  onChange={value => changeTo(value)} user={user}/>
        )
      }
      {
        pageInfo.page === 'history' && (
          <ShoppingHistory onChange={value => changeTo(value)} user={user}/>
        )
      }
      {
        pageInfo.page === 'userAgreement' && (
          <div className="content">
            <div className="breadcrumb" onClick={() => changeTo('landing')}>&lsaquo; <span>Palaa takaisin</span></div>
            <UserAgreement onChange={value => changeTo(value)}/>
          </div>
        )
      }

      </div>

    </div>
    <Footer onChange={value => changeTo(value)} />
    </>
  );

}
export default Profile;
